import { render } from "./Agente.vue?vue&type=template&id=6b2adf3a&scoped=true"
import script from "./Agente.vue?vue&type=script&lang=ts"
export * from "./Agente.vue?vue&type=script&lang=ts"

import "./Agente.vue?vue&type=style&index=0&id=6b2adf3a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6b2adf3a"

export default script